import React, { useCallback, useEffect } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';
import classNames from 'classnames';

import {
  learnerEmailsSelector,
  pastClassesStatusSelector,
  resetEditCrashCourseBatch,
  selectedSuperBatchSelector,
  upcomingClassesStatusSelector,
  useDissociateMenteeToBatchMutation,
} from 'features/classCreation';
import GlobalLoader from 'components/GlobalLoader';
import styles from './RemoveLearnersButton.module.scss';

function RemoveLearnersButton() {
  const dispatch = useDispatch();
  const superBatch = useSelector(selectedSuperBatchSelector);
  const learnerEmails = useSelector(learnerEmailsSelector);
  const pastClassesStatus = useSelector(pastClassesStatusSelector);
  const upcomingClassesStatus = useSelector(upcomingClassesStatusSelector);

  const [removeLearners, { isSuccess, error, isLoading: isRemoving }] =
    useDissociateMenteeToBatchMutation();

  const handleOnClick = useCallback(() => {
    removeLearners({
      superBatchId: superBatch.id,
      emails: learnerEmails,
      completedClassesStatus: pastClassesStatus,
      upcomingClassesStatus,
    });
  }, [
    learnerEmails,
    pastClassesStatus,
    removeLearners,
    superBatch.id,
    upcomingClassesStatus,
  ]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success(
        'Changes updated successfully! Learners are removed from the Super Batch'
      );
      dispatch(resetEditCrashCourseBatch());
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error.data?.message || 'Something went wrong! Try again later.'
      );
    }
  }, [error]);

  return (
    <>
      <GlobalLoader isVisible={isRemoving} />
      <Tappable
        onClick={handleOnClick}
        className={classNames('btn btn-primary', styles.root)}
        disabled={isRemoving}
      >
        Confirm
      </Tappable>
    </>
  );
}

export default RemoveLearnersButton;
